// utils
import uuid from "../../utils/GenerateUUID";
import get from "../../utils/GetNested";

/**
 * A class that creates a pub/sub system outside of the redux store. This will
 * allow different components to communicate without needing to update a store
 * value.
 */
class PubSub {
	constructor() {
		this.topics = {};
	}

	/**
	 * Safely gets a topic from the topics list
	 */
	getTopic(name) {
		const topics = get(this.topics, [name], null);
		return topics;
	}

	/**
	 * Creates a topic if the topic doesn't exist
	 */
	createTopic(name) {
		const topic = this.getTopic(name);

		if (!topic) {
			this.topics[name] = [];
		}
	}

	/**
	 * Publishes data to a topic
	 */
	publish(name, data) {
		const topic = this.getTopic(name);

		if (!topic) {
			return;
		}

		topic.forEach((item) => item.action.call(this, data));
	}

	/**
	 * Adds a subscription to the specified topic. When data is published to
	 * the topic, the action will be called.
	 */
	subscribe(name, action) {
		this.createTopic(name);
		const topic = this.getTopic(name);

		const id = uuid();

		// add to the list of topics
		topic.push({
			id,
			action,
		});

		return {
			id,
			topic: name,
			index: topic.length - 1,
			remove: () => this.removeAction(name, id),
		};
	}

	/**
	 * Removes an entire channel
	 */
	removeChannel(name) {
		const topic = this.getTopic(name);

		if (!topic) {
			return;
		}

		delete this.channels[name];
	}

	/**
	 * Removes an action from the channel by its ID.
	 */
	removeAction(name, id) {
		const topic = this.getTopic(name);

		if (!topic) {
			return {
				topic: name,
				length: topic.length,
			};
		}

		// create new topic list
		const newTopicArr = topic.filter((item) => item.id !== id);

		// update the topic list
		this.topics[name] = newTopicArr;

		return {
			topic: name,
			length: newTopicArr.length,
		};
	}
}

export default PubSub;
